import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CookiesService {
  tokenFromUI:string = "TYASuite!#!TYASuite!TYASuite!#!@";

  constructor() { }

  /**
   * Helper method to build cookie string with appropriate flags based on protocol (HTTP/HTTPS)
   * @param name Cookie name
   * @param value Cookie value
   * @returns Cookie string with appropriate flags
   */
  private buildCookieString(name: string, value: string): string {
    const isHttps = window.location.protocol === 'https:';
    const hostname = window.location.hostname;
    const path = '/';
    
    // Don't set domain for localhost or IP addresses - it will cause cookie issues
    // Only set domain for actual domain names (not localhost, 127.0.0.1, etc.)
    const shouldSetDomain = hostname !== 'localhost' && 
                           hostname !== '127.0.0.1' && 
                           !hostname.match(/^\d+\.\d+\.\d+\.\d+$/);
    const domainPart = shouldSetDomain ? `; domain=${hostname}` : '';
    
    // Log protocol detection
    //console.log(`[CookieService] buildCookieString - Protocol: ${window.location.protocol}, isHttps: ${isHttps}, Hostname: ${hostname}, ShouldSetDomain: ${shouldSetDomain}`);
    
    if (isHttps) {
      // For HTTPS: use secure flag and SameSite=None (for cross-site support)
      // Note: SameSite=None requires Secure flag and proper capitalization
      const cookieString = `${name}=${value}; path=${path}${domainPart}; secure; SameSite=None`;
     // console.log(`[CookieService] buildCookieString (HTTPS) - Cookie string: ${cookieString.substring(0, 150)}...`);
      return cookieString;
    } else {
      // For HTTP: use SameSite=Lax (secure flag won't work on HTTP)
      const cookieString = `${name}=${value}; path=${path}${domainPart}; SameSite=Lax`;
      //console.log(`[CookieService] buildCookieString (HTTP) - Cookie string: ${cookieString.substring(0, 150)}...`);
      return cookieString;
    }
  }

  setUserName(userName: any) {
    // Old code - had incorrect syntax: secure flag was appended to value instead of being a cookie attribute
    // Cookie.set("accesstoken", this.set(userName)+";secure")
    // document.cookie = "accesstoken = "+this.set(userName)+";secure";
    //console.log(`[CookieService] setUserName - Input userName: ${userName ? userName.substring(0, 20) + '...' : 'empty'}`);
    const encryptedValue = this.set(userName);
    //console.log(`[CookieService] setUserName - Encrypted value length: ${encryptedValue ? encryptedValue.length : 0}`);
    
    Cookie.set("accesstoken", encryptedValue)
    const cookieString = this.buildCookieString("accesstoken", encryptedValue);
    document.cookie = cookieString;
    
    // Verify cookie was set
    const allCookies = document.cookie;
    const cookieExists = allCookies.indexOf('accesstoken=') !== -1;
    //console.log(`[CookieService] setUserName - Cookie set attempt. Cookie exists in document.cookie: ${cookieExists}`);
    //console.log(`[CookieService] setUserName - All cookies: ${allCookies.substring(0, 200)}...`);

  }

  setPassword(password: any) {
    // Old code - had incorrect syntax: secure flag was appended to value instead of being a cookie attribute
    // Cookie.set("accesskey", this.set(password)+";secure")
    // document.cookie = "accesskey="+this.set(password)+";secure";
    //console.log(`[CookieService] setPassword - Input password length: ${password ? password.length : 0}`);
    const encryptedValue = this.set(password);
    //console.log(`[CookieService] setPassword - Encrypted value length: ${encryptedValue ? encryptedValue.length : 0}`);
    
    Cookie.set("accesskey", encryptedValue)
    const cookieString = this.buildCookieString("accesskey", encryptedValue);
    document.cookie = cookieString;
    
    // Verify cookie was set
    const allCookies = document.cookie;
    const cookieExists = allCookies.indexOf('accesskey=') !== -1;
    //console.log(`[CookieService] setPassword - Cookie set attempt. Cookie exists in document.cookie: ${cookieExists}`);

  }
  setIsRem(isRemember: any) {
    // Old code - had incorrect syntax: secure flag was appended to value instead of being a cookie attribute
    // Cookie.set("is_log_rem", this.set(isRemember)+";secure")
    // document.cookie = "is_log_rem="+this.set(isRemember)+";secure";
    const encryptedValue = this.set(isRemember);
    Cookie.set("is_log_rem", encryptedValue)
    document.cookie = this.buildCookieString("is_log_rem", encryptedValue);

  }

  setrememberMe(isRemember: any) {
    // Old code - had incorrect syntax: secure flag was appended to value instead of being a cookie attribute
    // Cookie.set("accessrem", this.set(isRemember)+";secure")
    // document.cookie = "accessrem="+this.set(isRemember)+";secure";
    //console.log(`[CookieService] setrememberMe - Input isRemember: ${isRemember}`);
    const encryptedValue = this.set(isRemember);
    //console.log(`[CookieService] setrememberMe - Encrypted value: ${encryptedValue}`);
    
    Cookie.set("accessrem", encryptedValue)
    const cookieString = this.buildCookieString("accessrem", encryptedValue);
    document.cookie = cookieString;
    
    // Verify cookie was set
    const allCookies = document.cookie;
    const cookieExists = allCookies.indexOf('accessrem=') !== -1;
    //console.log(`[CookieService] setrememberMe - Cookie set attempt. Cookie exists in document.cookie: ${cookieExists}`);
    //console.log(`[CookieService] setrememberMe - Cookie value from ng2-cookies: ${Cookie.get("accessrem")}`);

  }

  setCompanyAccessToken(token:any)
  {
    // Old code - had incorrect syntax: secure flag was appended to value instead of being a cookie attribute
    // Cookie.set("access_token",this.set(token));
    // document.cookie = "access_token="+this.set(token)+";secure";
    const encryptedValue = this.set(token);
    Cookie.set("access_token", encryptedValue);
    document.cookie = this.buildCookieString("access_token", encryptedValue);

  }
  getCompanyAccessToken()
  {
    return this.get('access_token',Cookie.get("access_token"),'1');
  }
  getUserName() {
    const rawCookie = Cookie.get("accesstoken");
    //console.log(`[CookieService] getUserName - Raw cookie from ng2-cookies: ${rawCookie ? rawCookie.substring(0, 50) + '...' : 'null/undefined'}`);
    //console.log(`[CookieService] getUserName - document.cookie contains accesstoken: ${document.cookie.indexOf('accesstoken=') !== -1}`);
    const decryptedValue = this.get('accesstoken', rawCookie, '1');
    //console.log(`[CookieService] getUserName - Decrypted value: ${decryptedValue ? decryptedValue.substring(0, 20) + '...' : 'null/undefined'}`);
    return decryptedValue;
  }

  getPassword() {
    const rawCookie = Cookie.get("accesskey");
    //console.log(`[CookieService] getPassword - Raw cookie from ng2-cookies: ${rawCookie ? rawCookie.substring(0, 50) + '...' : 'null/undefined'}`);
    //console.log(`[CookieService] getPassword - document.cookie contains accesskey: ${document.cookie.indexOf('accesskey=') !== -1}`);
    const decryptedValue = this.get('accesskey', rawCookie, '1');
    //console.log(`[CookieService] getPassword - Decrypted value length: ${decryptedValue ? decryptedValue.length : 0}`);
    return decryptedValue;
  }
  getrememberMe() {
    const rawCookie = Cookie.get("accessrem");
    //console.log(`[CookieService] getrememberMe - Raw cookie from ng2-cookies: ${rawCookie ? rawCookie : 'null/undefined'}`);
    //console.log(`[CookieService] getrememberMe - document.cookie contains accessrem: ${document.cookie.indexOf('accessrem=') !== -1}`);
    //console.log(`[CookieService] getrememberMe - Full document.cookie: ${document.cookie}`);
    const decryptedValue = this.get('accessrem', rawCookie, '1');
    //console.log(`[CookieService] getrememberMe - Decrypted value: ${decryptedValue}`);
    return decryptedValue;
  }
  set(value,key?:string)
  {
    // console.log(value);
    // console.log(key);
  // try{
  //   if(localStorage.getItem('is_enc_on')=='MQ=='||key=='is_enc_on'||key=='is_login_psw')
  //   // if(localStorage.getItem('is_enc_on')=='MQ==')
  //   {
  //     return btoa(value);
  //   }
  //   else
  //   {
  //     return value
  //   }
  // }
  // catch(e)
  // {
  // return value
  // }
  let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
  let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
  try{
     if(localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='||key=='is_enc_on'||key=='is_login_psw')
     {
      return CryptoJS.AES.encrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString();
     }
    }
     catch(e)
     {
       console.log(e.name);
       console.log(e.message);
  return value
     }

  }
  get(key,value,is_cookie?:string)
  {
  //   try {
  //   if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && localStorage.getItem('is_enc_on')=='MQ==')
  //   {
  //     // console.log('hey3');

  //     return (atob(value)!=''&&atob(value)!=undefined&&atob(value)!=null)?(this.isJSON(atob(value))?JSON.parse(atob(value)):atob(value)):value;

  //   }
  //   else
  //   {
  //     return (this.isJSON(value)?JSON.parse(value):value);
  //   }
  // }
  // catch(e)
  // {
  //   console.error('enc/dec logout key'+key,'value='+value)
  //   window.localStorage.clear();
  //   window.location.href=window.location.origin+"/#/login"
  // }
  //console.log(`[CookieService] get - Key: ${key}, Value exists: ${value ? 'yes' : 'no'}, Value length: ${value ? value.length : 0}, is_cookie: ${is_cookie}`);
  
  // Check if value is null/undefined/empty
  if (!value || value === '' || value === 'null' || value === 'undefined') {
    console.warn(`[CookieService] get - Value is empty/null/undefined for key: ${key}`);
    return value;
  }
  
  let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
  let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI).toString();
  try {
      if(localStorage.getItem(key)!=null && localStorage.getItem(key)!='' && localStorage.getItem(key)!=undefined && (localStorage.getItem('is_enc_on')=='rL1SUvvPuiEUY30i7mxdOg=='&&is_cookie!='1'))
      {
        let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
        //console.log(`[CookieService] get - Decryption successful (localStorage path), decrypted length: ${dec ? dec.length : 0}`);
        return this.isJSON(dec)?JSON.parse(dec):dec;
      }
      if(is_cookie=='1')
      {
        //console.log(`[CookieService] get - Attempting cookie decryption for key: ${key}`);
        let dec:any=CryptoJS.AES.decrypt(value.trim(),_key,{keySize: 256,iv:_iv, mode: CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7}).toString(CryptoJS.enc.Utf8)
        //console.log(`[CookieService] get - Decryption successful (cookie path), decrypted value: ${dec ? (dec.length > 50 ? dec.substring(0, 50) + '...' : dec) : 'empty'}`);
        return this.isJSON(dec)?JSON.parse(dec):dec;
      }
      
      // If neither condition met, return value as-is
      //console.log(`[CookieService] get - No decryption applied, returning value as-is`);
      return value;
    }
    catch(e)
    {
      console.error(`[CookieService] get - Decryption error for key: ${key}`, e);
      console.error(`[CookieService] get - Error name: ${e.name}, Error message: ${e.message}`);
      console.error(`[CookieService] get - Value that failed: ${value ? value.substring(0, 100) : 'null'}`);
      // Don't clear localStorage and redirect on cookie decryption failure - just return empty/null
      if(is_cookie!='1') {
        window.localStorage.clear();
        window.location.href=window.location.origin+"/#/login"
      } else {
        console.warn(`[CookieService] get - Cookie decryption failed, returning null`);
        return null;
      }
    }

  }
isJSON(str) {
  try {
      return (JSON.parse(str));
  } catch (e) {
      return false;
  }
}
}



// WEBPACK FOOTER //
// /codebuild/output/src1440768160/src/src/app/shared/services/storage/cookies.service.ts